import React from "react";
import { Clock } from "lucide-react";
import { ModernSheet } from "components/common/ModernSheet/ModernSheet";
import { LoaderV2, LoaderMode, LoaderTheme } from "components/common/LoaderV2/LoaderV2";

// Loading messages for project settings
const projectSettingsTexts = [
  "Loading your account information...",
  "Checking available licenses...",
  "Verifying subscription status...",
  "Preparing project creation...",
  "Setting up form fields...",
  "Ready to create your project...",
];

interface LoadingStateProps {
  isOpen: boolean;
  onClose: () => void;
}

export const LoadingState: React.FC<LoadingStateProps> = ({ isOpen, onClose }) => {
  return (
    <ModernSheet
      isOpen={isOpen}
      onClose={onClose}
      title="Loading..."
      description="Loading project settings..."
      size="xl"
      className="max-h-screen"
    >
      <div className="flex-1 p-6 flex items-center justify-center">
        <div className="text-center">
          <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center mb-4 mx-auto">
            <Clock className="w-6 h-6 text-primary" />
          </div>
          <h4 className="text-sm font-medium text-foreground mb-2">Loading Project Settings</h4>
          <LoaderV2
            mode={LoaderMode.inline}
            theme={LoaderTheme.brand}
            size="sm"
            rotatingTexts={projectSettingsTexts}
            textInterval={1500}
            textClassName="text-muted-foreground text-xs"
          />
        </div>
      </div>
    </ModernSheet>
  );
};
